import { render, staticRenderFns } from "./societyMngDetail.vue?vue&type=template&id=15dae7da&"
import script from "./societyMngDetail.vue?vue&type=script&lang=js&"
export * from "./societyMngDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports